
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consorcio",
      function () {
        return require("private-next-pages/consorcio/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/consorcio"])
      });
    }
  